import { render, staticRenderFns } from "./mvAddFamilyModify.vue?vue&type=template&id=71c84a68&scoped=true"
import script from "./mvAddFamilyModify.vue?vue&type=script&lang=js"
export * from "./mvAddFamilyModify.vue?vue&type=script&lang=js"
import style0 from "./mvAddFamilyModify.vue?vue&type=style&index=0&id=71c84a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c84a68",
  null
  
)

export default component.exports